import jqLiteExtras from './shared/jqLiteExtras.js';

function runBlock(environment, $window, Alerts, $rootScope) {
  'ngInject';

  document.domain = environment.domain;
  jqLiteExtras.init();

  $rootScope.baseUrl = environment.site.parent;

  try {
    let key = 'testingLocalStorage';
    window.localStorage.setItem(key, 'test');
    window.localStorage.removeItem(key);
  } catch (error) {
    Alerts.add({type: 'danger', message: '<b>ERROR:</b> It looks like you are using private browsing on your iOS device. To get the best experience please <b>disable</b> private browsing.'});
  }

  //Facebook JS SDK
  $window.fbAsyncInit = function() {
    window.FB.init({appId: environment.social.facebook.appId, status: true, cookie: true, xfbml: true, version: 'v2.4'});
  };
  /* jshint ignore:start */

  //Facebook SDK
  (function(d, s, id) {
    var js,
      fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement(s);
    js.id = id;
    js.src = "//connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));

  //Facebook Pixels - For Production
  if (environment.name === 'Production') {
    //Facebook Pixel tracking
    !function(f, b, e, v, n, t, s) {
      if (f.fbq)
        return;
      n = f.fbq = function() {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      };

      if (!f._fbq)
        f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';

      n.queue = [];
      t = b.createElement(e);
      t.async = !0;

      t.src = v;
      s = b.getElementsByTagName(e)[0];

      s.parentNode.insertBefore(t, s)
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    fbq('init', environment.social.facebook.pixels.visitor);

    fbq('track', 'PageView');
  }

  //Google Analytics SDK
  (function(i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function() {
      (i[r].q = i[r].q || []).push(arguments)
    },
    i[r].l = 1 * new Date();
    a = s.createElement(o),
    m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m)
  })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
  ga('create', environment.googleAnalytics, environment.name !== 'Development'
    ? 'auto'
    : 'none');
  /* jshint ignore:end */
}
export default runBlock;



/** WEBPACK FOOTER **
 ** ./src/app/app.run.js
 **/